<template>
  <meta
    name="viewport"
    content="width=device-width, initial-scale=1, maximum-scale=1"
  />
  <Suspense>
    <router-view />
  </Suspense>
</template>

<style lang="scss">
@import url("https://rsms.me/inter/inter.css");
body,
html {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background: $main-background;
}

#app {
  height: 100%;
  font-family: "Inter", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $main-black;
  background: $main-background;

  .card-container {
    background: $card-background-color;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding-left: 32px;
    padding-right: 32px;
  }

  .field > label {
    display: block;
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 6px;
  }

  .field > input {
    width: 100%;
    height: 32px;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    font-size: 16px;
    font-weight: 400;
    padding: 16px 10px;
  }

  input:focus-visible,
  button:focus {
    outline: none !important;
  }

  button:focus {
    box-shadow: none;
  }

  .p-selectbutton {
    .p-button.p-highlight {
      background: $main-red;
    }
  }

  .btn-primary {
    background: $main-red;
    font-weight: 500;
    font-size: 16px;
    border-radius: 4px;
    border: 1px solid $main-red;
    padding: 8px 24px;

    &:disabled {
      opacity: 0.8;
    }
  }

  .btn-primary-txt-only {
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    color: $main-red;
    background: none;
    border: none;
  }

  .form-error-text {
    color: #ff3f3f;
    font-weight: 500;
  }

  .info-text {
    font-weight: 600;
    font-size: 13px;
  }

  h3 {
    font-weight: 600;
    font-size: 28px;
    color: $black-text;
  }

  .header-sub-text {
    color: $black-text;
    font-size: 16px;
    font-weight: 500;
    line-height: 19px;
  }

  .float-left {
    float: left;
  }

  .float-right {
    float: right;
  }

  .mt-10px {
    margin-top: 10px;
  }

  .mb-6px {
    margin-bottom: 6px;
  }

  .device-reading-card {
    background-color: $card-background-color;
    border-radius: 14px;
    padding-top: 16px;
    margin: 6px;
    padding-bottom: 16px;
    padding-left: 20px;
    padding-right: 20px;

    .placeholder-wave {
      .value {
        height: 38px;
      }
      .placeholder {
        opacity: 0.2;
        border-radius: 5px;
      }
    }

    .reading-name-title {
      font-size: 16px;
      font-weight: 500;
      line-height: 19px;
      letter-spacing: 0em;
      text-align: left;
      color: $black-text;
      opacity: 75%;
      display: inline;
      vertical-align: middle;
    }
  }

  .pulse-heart {
    height: 12.15px;
    vertical-align: unset;
    margin-right: 5px;
  }

  .device-reading-date {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.07px;
    text-align: left;
    color: $black-text;
  }

  .device-reading-value-section {
    display: flex;
    margin-bottom: 6px;
    align-items: center;

    .device-reading-value {
      font-style: normal;
      font-weight: 500;
      font-size: 28px;
      line-height: 34px;
    }

    .chevron {
      height: 12px;
      margin-left: auto;
      order: 2;
    }

    .unit {
      display: inline;
      font-weight: 500;
      font-size: 16px;
      line-height: 26px;
      color: $black-text;
      opacity: 70%;
    }
  }
}

.link-primary {
  font-size: 16px;
  color: $main-red !important;

  &:hover {
    color: $main-red;
  }
}

.secondary-btn {
  font-size: 16px;
  font-weight: 500;
  background: $card-background-color;
  border: 1px solid #999999;
  color: $main-black;
  border-radius: 4px;
  padding: 8px 24px;
}

.p-component-overlay {
  background-color: rgba(0, 0, 0, 0.4);
  transition-duration: 0.15s;
}

.p-dialog {
  border-radius: 4px;
  box-shadow: none;
  border: 1px solid rgba(0, 0, 0, 0.2);
  font-family: Inter;

  .p-dialog-header {
    font-family: Inter;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;

    border-bottom: 1px solid #e9ecef;
    background: $card-background-color;
    color: #1f1f1f;
    padding: 1rem;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
  }

  .p-dialog-content {
    background: $card-background-color;
    color: #212529;
    padding: 1rem;
    &:last-of-type {
      border-bottom-right-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }
}
</style>
